/**
 * Map ISO 20022 status codes to user-friendly failure messages.
 * See https://www.iso20022.org/catalogue-messages/additional-content-messages/external-code-sets
 */
export const getIsoStatusMessage = (isoStatusCode: string | null | undefined): string | null => {
  if (!isoStatusCode) return null;

  const isoMessages: Record<string, string> = {
    // Rejection codes
    AC01: 'The account number is invalid or missing.',
    AC04: 'The account is closed.',
    AC06: 'The account is blocked.',
    AM04: 'Insufficient funds in your account.',
    AM09: 'The amount exceeds the allowed limit.',
    AM18: 'The number of transactions exceeds the limit.',
    BE04: 'The creditor address is missing or incomplete.',
    BE05: 'The creditor identifier is invalid.',
    CUST: 'The payment was cancelled by you.',
    DS02: 'Your request was cancelled by an authorised party.',
    FF01: 'The file format is invalid.',
    MD01: 'No valid mandate exists for this payment.',
    MS02: 'The payment could not be authorised.',
    MS03: 'The payment could not be authorised.',
    NOAS: 'No response from the bank.',
    RR01: 'The regulatory information is missing.',
    RR02: 'The debtor or creditor identification is missing.',
    RR03: 'The debtor name is missing.',
    RR04: 'The regulatory reason is invalid.',
    SL01: 'The payment requires a specific service level.',
    TM01: 'The payment has expired.',
    RJCT: 'The payment was rejected by the bank.',
  };

  return isoMessages[isoStatusCode] ?? null;
};
